import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../../enums';
import { Modal } from '../../../common';

export const LearnMoreAboutCuffModal = () => {
  const { t } = useTranslation();

  return (
    <Modal name={ModalName.LEAR_MORE_ABOUT_CUFF} header={t('modal.learnMoreAboutCuff.title')}>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutCuff.approach.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary mb-6">
        {t('modal.learnMoreAboutCuff.approach.description')}
      </p>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutCuff.preparation.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary-600 mb-6">
        <span className="whitespace-pre-line">{t('modal.learnMoreAboutCuff.preparation.description1')}</span>
        <ol className="mt-1 mb-1 flex justify-between">
          <div className="w-1/2">
            <li>{t('modal.learnMoreAboutCuff.preparation.list.caffeine')}</li>
            <li>{t('modal.learnMoreAboutCuff.preparation.list.food')}</li>
          </div>
          <div className="w-1/2">
            <li>{t('modal.learnMoreAboutCuff.preparation.list.exercise')}</li>
            <li>{t('modal.learnMoreAboutCuff.preparation.list.smoking')}</li>
          </div>
        </ol>
        <span className="whitespace-pre-line">{t('modal.learnMoreAboutCuff.preparation.description2')}</span>
      </p>
      <span className="typography-title-2 text-text-primary">{t('modal.learnMoreAboutCuff.measurement.title')}</span>
      <p className="typography-paragraph-3 text-text-secondary mb-6">
        {t('modal.learnMoreAboutCuff.measurement.description')}
      </p>
    </Modal>
  );
};
